import { GlobalStates } from "./GlobalStatesHelper";

export function Autocomplete(value, itens, param) {
  let newResults = [];
  for (let s in itens) {
    const item = itens[s];
    const info = item[param].toLowerCase();
    if (info.includes(value.toLowerCase())) {
      newResults.push(item);
    }
  }
  return newResults;
}

export function GetStateCode(name) {
  const result = GlobalStates.filter(x => x.subdivision_name.toLowerCase().includes(name.toLowerCase()));
  if (result.length > 0) {
    return result[0].code;
  } else {
    return "";
  }
}